import { format } from 'date-fns';

export const getValueColor = (isMultiAsset: boolean, value?: number) => {
  if (!isMultiAsset || value === undefined) {
    return undefined;
  }

  if (value > 0) {
    return 'var(--text-success)';
  }

  if (value < 0) {
    return 'var(--text-critical)';
  }

  return undefined;
};

export const formatDate = (date: Date, locale: string) => {
  const time = format(date, 'h:mm a');
  const dateStr = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
  }).format(date);

  return `${time}, ${dateStr}`;
};
